import classnames from 'classnames';
import {ComponentProps, ElementType} from 'react';
import {Link} from 'react-router';
import {FCC} from 'types/react';

import {Icon} from 'components/Icon/Icon';

import styles from './Button.module.css';

export enum ButtonType {
    Primary = 'Primary',
    PrimaryOutline = 'PrimaryOutline',
    Secondary = 'Secondary',
    SecondaryOutline = 'SecondaryOutline',
    SecondaryLightOutline = 'SecondaryLightOutline',
    FillLight = 'FillLight',
}
const TYPE_CLASS_NAMES = {
    [ButtonType.Primary]: styles.primary,
    [ButtonType.PrimaryOutline]: styles.primaryOutline,
    [ButtonType.Secondary]: styles.secondary,
    [ButtonType.SecondaryOutline]: styles.secondaryOutline,
    [ButtonType.SecondaryLightOutline]: styles.secondaryLightOutline,
    [ButtonType.FillLight]: styles.fillLight,
};

export enum ButtonSize {
    L = 'L',
    M = 'M',
    S = 'S',
    XS = 'XS',
}
const SIZE_CLASS_NAMES = {
    [ButtonSize.L]: styles.sizeL,
    [ButtonSize.M]: styles.sizeM,
    [ButtonSize.S]: styles.sizeS,
    [ButtonSize.XS]: styles.sizeXs,
};

type Props = {
    type?: ButtonType;
    submit?: boolean;
    link?: string;
    disabled?: boolean;
    size?: ButtonSize;
    component?: ElementType;
    className?: string;
    onClick?: () => void;
    fullWidth?: boolean;
    iconName?: ComponentProps<typeof Icon>['name'];
};

export const Button: FCC<Props> = ({
    children,
    type = ButtonType.Primary,
    size = ButtonSize.M,
    className,
    submit,
    disabled,
    component: ComponentProp = 'button',
    onClick,
    link,
    iconName,
    fullWidth,
}) => {
    const typeClassName = TYPE_CLASS_NAMES[type];
    const sizeClassName = SIZE_CLASS_NAMES[size];

    const nativeButtonType = submit ? 'submit' : 'button';

    const Component = ComponentProp;

    const linkProps = Component === Link ? {to: link} : {href: link};

    return (
        <Component
            className={classnames(
                styles.block,
                typeClassName,
                sizeClassName,
                className,
                {
                    [styles.withIcon]: Boolean(iconName),
                    [styles.fullWidth]: fullWidth,
                },
            )}
            type={nativeButtonType}
            onClick={onClick}
            disabled={disabled}
            {...linkProps}
        >
            {iconName && <Icon name={iconName} />}
            {children}
        </Component>
    );
};
